import { Link } from "react-router-dom";
import HabitusPayLogo from "@/components/HabitusPayLogo";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const openCookieSettings = () => {
    localStorage.removeItem("cookie_consent");
    window.dispatchEvent(new CustomEvent("openCookieSettings"));
  };

  const links = {
    legal: [
      { label: "Aviso Legal", href: "/aviso-legal" },
      { label: "Política de Privacidad", href: "/privacidad" },
      { label: "Términos del Servicio", href: "/terminos" },
      { label: "Política de Cookies", href: "/cookies" },
    ],
    product: [
      { label: "Producto", href: "/#producto" },
      { label: "Soluciones", href: "/#soluciones" },
      { label: "Precios", href: "/#precios" },
      { label: "FAQ", href: "/#faq" },
      { label: "Contacto", href: "/#contacto" },
    ],
  };

  return (
    <footer className="bg-primary text-primary-foreground" role="contentinfo">
      <div className="container mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-2">
            <div className="mb-4">
              <HabitusPayLogo variant="light" />
            </div>
            <p className="text-sm text-primary-foreground/80 max-w-sm mb-4">
              Plataforma de gestión financiera diseñada para el sector inmobiliario. 
              Controla gastos, gestiona tarjetas y simplifica tu contabilidad.
            </p>
            <p className="text-sm text-primary-foreground/70">
              Contacto: <a href="mailto:soporte@habituspay.com" className="hover:text-primary-foreground transition-colors underline-offset-2 hover:underline">soporte@habituspay.com</a>
            </p>
          </div>

          {/* Product Links */}
          <nav aria-label="Navegación del producto">
            <h4 className="font-semibold mb-4">Producto</h4>
            <ul className="space-y-2" role="list">
              {links.product.map((link) => (
                <li key={link.label}>
                  <a 
                    href={link.href}
                    className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors underline-offset-2 hover:underline"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* Legal Links */}
          <nav aria-label="Navegación legal">
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="space-y-2" role="list">
              {links.legal.map((link) => (
                <li key={link.label}>
                  <Link 
                    to={link.href}
                    className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors underline-offset-2 hover:underline"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <button
                  onClick={openCookieSettings}
                  className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors underline-offset-2 hover:underline"
                  type="button"
                >
                  Configurar Cookies
                </button>
              </li>
            </ul>
          </nav>
        </div>

        {/* Disclaimer */}
        <div className="mt-10 pt-6 border-t border-primary-foreground/20">
          <p className="text-xs text-primary-foreground/70 text-center max-w-3xl mx-auto">
            HabitusPay es software de gestión. Servicios de tarjetas prestados por proveedores externos regulados.
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="mt-6 pt-6 border-t border-primary-foreground/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-primary-foreground/70">
              © {currentYear} HABITUSPAY ESPAÑA SL · CIF B24795155
            </p>
            <div className="flex items-center gap-4">
              <a 
                href="https://linkedin.com/company/habituspay" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-primary-foreground/70 hover:text-primary-foreground transition-colors"
                aria-label="LinkedIn de HabitusPay (abre en nueva ventana)"
              >
                LinkedIn
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
